<div class="report-card">
  <div class="h3 secondary-text">{{reportName | translate}}</div>
  <div class="font-size-54 font-weight-300" fxLayoutAlign="start end">
    {{reportValue}}
  </div>
</div>